import React, { useState, useEffect, forwardRef } from "react";
import { useParams } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaSignOutAlt } from "react-icons/fa";
import VirtualIDCard from "./VirtualIDCard";
import ChangePasswordModal from "./ChangePasswordModal";
import { isPendingUser } from "../../../../utils/userPermissions";
import API_BASE_URL, { API_ENDPOINTS } from '../../../../config/api';

const getProfilePictureSrc = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
    return path;
  }
  return `${API_BASE_URL}/${path}`;
};

export default function Header() {
  const { uid } = useParams();
  const [user, setUser] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showVirtualId, setShowVirtualId] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    fetch(API_ENDPOINTS.USERS.DISPLAY(uid))
      .then((res) => res.json())
      .then((data) => setUser(data))
      .catch((err) => console.error("User fetch error:", err));
  }, [uid]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const userInitial = user?.name?.charAt(0).toUpperCase() || "";
  const profilePhotoUrl = user?.profilePhoto || user?.profilePicture;

  const CustomToggle = forwardRef(({ onClick }, ref) => (
    <button
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="db1-avatar"
      style={{
        width: 40,
        height: 40,
        fontSize: "0.95rem",
        fontWeight: 600,
        border: "none",
        cursor: "pointer",
        padding: 0,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {profilePhotoUrl ? (
        <img
          src={getProfilePictureSrc(profilePhotoUrl)}
          alt="Profile"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "12px",
          }}
        />
      ) : (
        userInitial
      )}
    </button>
  ));

  return (
    <div className="db1-header" style={{
      position: "fixed",
      top: 0,
      left: windowWidth >= 768 ? 250 : 0,
      right: 0,
      height: 60,
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 24px',
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: 1 }}>
        {windowWidth < 768 && (
          <button
            className="btn btn-light"
            onClick={() =>
              document.querySelector('[style*="z-index: 2001"]')?.click()
            }
            style={{
              padding: "6px 8px",
              fontSize: "1.2rem",
              lineHeight: 1,
              color: "#ac2e62",
              background: "rgba(172,46,98,0.06)",
              border: "none",
              borderRadius: "12px",
            }}
          >
            ☰
          </button>
        )}
        <div>
          <h5 className="mb-0 fw-bold" style={{ color: '#2c3e50', fontSize: '1.1rem', letterSpacing: '-0.3px' }}>
            Hello, {user?.name || "User"}
          </h5>
          <p className="mb-0" style={{ color: '#ac2e62', fontSize: '0.7rem', fontWeight: 600, opacity: 0.7, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Volunteer Dashboard
          </p>
        </div>

        {isPendingUser() && (
          <div style={{
            backgroundColor: "#fff3cd",
            color: "#856404",
            padding: "4px 12px",
            borderRadius: "999px",
            fontSize: "0.75rem",
            fontWeight: "500",
            border: "1px solid #ffeaa7",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            whiteSpace: 'nowrap'
          }}>
            <i className="fa fa-clock" style={{ fontSize: "0.7rem" }}></i>
            Pending Approval - Read Only
          </div>
        )}
      </div>

      <Dropdown align="end">
        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-toggle" />
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setShowVirtualId(true)}>
            View Virtual ID
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => setShowChangePassword(true)}>
            Change Password
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item
            onClick={() => {
              localStorage.clear();
              window.location.replace('/');
            }}
          >
            <FaSignOutAlt className="me-2" style={{ color: '#dc3545' }} />
            Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {showVirtualId && <VirtualIDCard uid={uid} onClose={() => setShowVirtualId(false)} />}

      <ChangePasswordModal
        show={showChangePassword}
        onHide={() => setShowChangePassword(false)}
      />
    </div>
  );
}
